import PropTypes from 'prop-types';
export var instrumentPropType = PropTypes.shape({
  OMSId: PropTypes.number.isRequired,
  InstrumentId: PropTypes.number.isRequired,
  Symbol: PropTypes.string.isRequired,
  Product1: PropTypes.number.isRequired,
  Product1Symbol: PropTypes.string.isRequired,
  Product2: PropTypes.number.isRequired,
  Product2Symbol: PropTypes.string.isRequired,
  InstrumentType: PropTypes.string.isRequired,
  VenueInstrumentId: PropTypes.number.isRequired,
  VenueId: PropTypes.number.isRequired,
  SortIndex: PropTypes.number.isRequired,
  SessionStatus: PropTypes.string.isRequired,
  PreviousSessionStatus: PropTypes.string.isRequired,
  SessionStatusDateTime: PropTypes.string.isRequired,
  SelfTradePrevention: PropTypes.bool.isRequired,
  QuantityIncrement: PropTypes.number.isRequired
});